import { getDefaultStore } from "jotai";

import { hangingProtocolActionsAtom } from "../../atoms/hangingProtocolAtoms";
import { registerCommand } from "./registry";

registerCommand("setWindowPreset", ({ center, width }) => {
  const store = getDefaultStore();
  store.set(hangingProtocolActionsAtom, { type: "SET_ALL_WINDOWING", center, width });
});
